import Marionette from 'backbone.marionette';
import NotificationItemView from '@/views/notification_item_view';
import $ from 'jquery';
import Handlebars from 'handlebars';
import notification_empty_template from '@/../templates/notification-empty-view.hbs';
import Radio from 'backbone.radio';

var globalCh = Radio.channel('global');
var apiCh = Radio.channel('api');

var NotificationDropdown = Marionette.CollectionView.extend( {
    className: 'notification-list list-group',
    tagName: 'ul',
    initialize: function() {
        this.on('select', this.change);
    },
    emptyView: Marionette.View.extend({
        template: Handlebars.compile(notification_empty_template),
    }),
    ui: {
        toggle: '.dropdown-toggle',
    },
    modelEvents: {'change': 'render'},   
    onRender: function() {
        const notifications = apiCh.request('notification');
        notifications.fetch();
        notifications.on('add', function() {
            notifications.sort();
        });
    },
    onAttach: function() {
        if (this.collection.length) {
            this.add_view_all_element();
        }
        this.listenTo(this.collection, 'add', ()=>{
            if (!this.has_view_all) {
                this.add_view_all_element();
            }
        });
    },
    handle_view_all: function(){
        var primary = globalCh.request('primary_account');
        globalCh.request('show_notifications_profile', primary);
    },
    add_view_all_element: function(){
        this.has_view_all = true;
        this.$el.after('<div class="view-all"><a class="view-all-link notification-view-all">View All</a></div>');
        $('.view-all-link').click(() => {
            this.handle_view_all();
        });
    },
    childView: NotificationItemView
});

export default NotificationDropdown;
